import { defineMessages } from 'react-intl'

export default defineMessages({
  cancelButton: {
    defaultMessage: 'Do not Delete',
    description: 'delete task modal | cancel button label',
  },
  confirmButton: {
    defaultMessage: 'Delete',
    description: 'delete task modal | confirm button label',
  },
  errorNotFound: {
    defaultMessage: 'Task not found',
    description: 'delete task modal | not found task error message',
  },
  modalMessage: {
    defaultMessage: 'Are you sure you want to delete task {taskReference}?',
    description: 'delete task modal | modal title label',
  },
  title: {
    defaultMessage: 'Delete Task',
    description: 'delete task modal | modal title label',
  },
  tryAgain: {
    defaultMessage: 'Try again',
    description: 'delete task modal | try again button label',
  },
  unknownError: {
    defaultMessage:
      'Something went wrong. You can try again below, or contact Support if the problem persists.',
    description: 'delete task modal | unknown error message',
  },
})
